export interface  TipoArquivo {
  idTipo:string;
  tipo:string;
  mostrar:boolean;
  numeroVersao:Int16Array;
}


export enum EnumTipoArquivo{
  TermoAditivoAssinado = "58FF0E5D-69CD-4876-B116-D7F1FBBD067E",
  NotaTecnicaTermoAditivo = "683F2625-A3F5-4887-9547-B000F72B5B79"
}



// WEBPACK FOOTER //
// ./src/app/models/tipoArquivo.ts